const Logo = () => {
  return (
    <div className="flex items-center flex-nowrap overflow-x-hidden gap-x-[10px] text-[20px] justify-center h-[100%]">
      <span>TCDA - OilPalm Digital Platform </span>
    </div>
  );
};

export default Logo;
